export default __webpack_public_path__ + "static/change-your-attitude-bdc8bbbf8232a4da212a3967bd010b40.jpg";